import {
  useFlags as useLaunchDarklyFlags,
  useLDClient,
  withLDProvider
} from 'launchdarkly-react-client-sdk';
import { flagMap } from './flag-map';

export const withFeatureFlagsProvider = (
  App: React.FC<React.PropsWithChildren>
) => {
  if (process.env['NX_REACT_APP_LAUNCH_DARKLY_CLIENT_SDK_KEY']) {
    return withLDProvider({
      clientSideID: process.env['NX_REACT_APP_LAUNCH_DARKLY_CLIENT_SDK_KEY'],
      flags: flagMap,
      context: {
        kind: 'user',
        key: 'anonymous'
      }
    })(App);
  }
  return App;
};
export const useFeatureFlagsClient = () => {
  return useLDClient();
};

export const useFlags = () => {
  return useLaunchDarklyFlags();
};
